import styled from 'styled-components';

export const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    min-height: ${props => props.size ? `${props.size}px` : 'calc(100vh - 60px)'};
    max-height: ${props => props.size ? `${props.size}px` : 'calc(100vh - 60px)'};
`;